import type { Components, Theme } from '@mui/material';

export const tabsCustomizations: Components<Theme> = {
  MuiTabs: {
    defaultProps: { textColor: 'inherit' },
    styleOverrides: {
      vertical: {
        overflow: 'visible',
      },
      indicator: ({ theme }) => ({
        backgroundColor: theme.palette.secondary.main,
      }),
    },
  },
};
